import { Routes } from '@angular/router';
import {
  avtaleTab,
  brokerPage,
  forbrukRoute,
  forbrukTab,
  nyttigTab,
  profilTab,
  regningTab,
  spotprisTab,
  enodeTab,
  analyseTab
} from '../routes';
import { TabsPage } from './tabs.page';

export const routes: Routes = [
  {
    path: '',
    component: TabsPage,
    children: [
      {
        title: 'Min Kundeprofil – Ishavskraft',
        path: profilTab,
        loadChildren: () =>
          import('./profil/profil.module').then((m) => m.ProfilPageModule)
      },
      {
        title: 'Nytt & Nyttig – Ishavskraft',
        path: nyttigTab,
        loadChildren: () =>
          import('./nyttig/nyttig.module').then((m) => m.NyttigPageModule)
      },
      {
        title: 'Strømregninger – Ishavskraft',
        path: regningTab,
        loadChildren: () =>
          import('./regninger/regninger.module').then(
            (m) => m.RegningerPageModule
          )
      },
      {
        title: 'Mine Avtaler – Ishavskraft',
        path: avtaleTab,
        loadChildren: () =>
          import('./avtaler/avtaler.module').then((m) => m.AvtalePageModule)
      },
      {
        title: 'Mitt Forbruk – Ishavskraft',
        path: forbrukTab,
        loadChildren: () =>
          import('./forbruk/forbruk.module').then((m) => m.ForbrukPageModule)
      },
      {
        title: 'Spotpris – Ishavskraft',
        path: spotprisTab,
        loadChildren: () =>
          import('./spot/spot.module').then((m) => m.SpotPageModule)
      },
      {
        title: 'Smartlading – Ishavskraft',
        path: enodeTab,
        loadChildren: () =>
          import('./enode/enode.module').then((m) => m.EnodePageModule)
      },
      {
        title: 'Din Strømanalyse – Ishavskraft',
        path: analyseTab,
        loadChildren: () =>
          import('./analyse/analyse.module').then(
            (m) => m.AnalyseComponentsModule
          )
      },

      {
        //Denne defaulten er bare hvis vi forsøker navigere til /tabs
        path: '',
        redirectTo: forbrukRoute,
        pathMatch: 'full'
      }
    ]
  }
];
